import ENDPOINTS from '@utils/apiEndpoints';
import { axiosInstance } from '@utils/axiosInstance';
import { onApiError, onApiSuccess } from '@utils/utilities';

export const externalDeliveryFileDeleteService = (data: any) => {
  return axiosInstance
    .delete(ENDPOINTS.ADMIN.EXTERNAL_DELIVERY.DELETE_FILE, { data })
    .then((response) => {
      return onApiSuccess(response);
    })
    .catch((error) => {
      return onApiError(error);
    });
};
